import { EnvConfig } from './types'

const defaultConfig: EnvConfig = {
  KEYCLOAK_DOMAIN: '',
  KEYCLOAK_CLIENT_ID: '',
  HEADER_ENRICHMENT_DOMAIN: '',
  KONG_APIKEY: '',
  ENDPOINT_DOMAIN: '',
  HOST: '',
  LOCIZE_PRIVATE_URL: '',
  LOCIZE_PROJECT_ID: '',
  LOCIZE_API_KEY: '',
  I18N_DEBUG: '',
  BUGSNAG_APIKEY: '',
  ENVIRONMENT: '',
}

export default defaultConfig
